import React, { useState, useEffect } from "react";
import Header from "../Components/Header";
import Footer from "../Components/Footer";
import { Link } from "react-router-dom";
import { getAllBlogs } from "./blogApi";

function Blog() {
  const [blogs, setBlogs] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 9;

  useEffect(() => {
    fetchBlogs();
  }, [currentPage]);

  const fetchBlogs = async () => {
    setLoading(true);
    setError(null);
    try {
      const data = await getAllBlogs(currentPage, itemsPerPage);
      setBlogs(data.blogs || []);
    } catch (err) {
      setError(err.message || "Failed to load blogs");
      console.error("Error fetching blogs:", err);
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <Header />

      {/*===== HERO AREA START =====*/}
      <div
        className="inner-hero"
        style={{ backgroundImage: "url(/assets/img/bg/Ashok.jpg)" }}
      >
        <div className="container">
          <div className="row">
            <div className="col-lg-8 m-auto text-center">
              <div className="inner-main-heading">
                <h1>Daily Blog</h1>
                <div className="breadcrumbs-pages">
                  {/* Breadcrumbs */}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/*===== HERO AREA END =====*/}

      {/*=== BLOG AREA START === */}
      <div className="blog6 sp">
        <div className="container">
          <div className="row">
            <div className="col-lg-6 m-auto text-center">
              {/* Section Title */}
            </div>
          </div>

          {/* Loading State */}
          {loading && (
            <div className="row mt-30">
              <div className="col-lg-12 text-center">
                <p>Loading blogs...</p>
              </div>
            </div>
          )}

          {/* Error State */}
          {error && (
            <div className="row mt-30">
              <div className="col-lg-12 text-center">
                <p style={{ color: "red" }}>Error: {error}</p>
              </div>
            </div>
          )}

          {/* No Blogs State */}
          {!loading && blogs.length === 0 && !error && (
            <div className="row mt-30">
              <div className="col-lg-12 text-center">
                <p>No blogs available yet.</p>
              </div>
            </div>
          )}

          {/* Blog Grid */}
          {!loading && blogs.length > 0 && (
            <div className="row mt-30">
              {blogs.map((blog) => (
                <div key={blog.id} className="col-lg-4 col-md-6">
                  <div
                    className="vl-blog-6-item mt-30"
                    data-aos="fade-up"
                    data-aos-duration={900}
                  >
                    <div className="vl-blog-6-content heading6">
                      <h4>
                        <Link to={`/blog/${blog.slug}`}>{blog.title}</Link>
                      </h4>
                    </div>
                    <div className="thumb-area">
                      <div className="vl-blog-6-thumb image-anime overflow-hidden _relative">
                        <img
                          className="w-full"
                          src={blog.image_url}
                          alt={blog.title}
                          style={{ height: "250px", objectFit: "cover" }}
                        />
                      </div>
                      <div className="vl-blog6-btn">
                        <Link
                          to={`/blog/${blog.slug}`}
                          className="learn"
                        >
                          Read More{" "}
                          <span className="arrow1">
                            <i className="fa-solid fa-arrow-right" />
                          </span>
                          <span className="arrow2">
                            <i className="fa-solid fa-arrow-right" />
                          </span>
                        </Link>
                      </div>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          )}

          {/* Pagination */}
          {!loading && blogs.length > 0 && (
            <div className="row mt-50">
              <div className="col-lg-12 text-center">
                <div style={{ display: "flex", justifyContent: "center", gap: "10px" }}>
                  <button
                    onClick={() => setCurrentPage(currentPage - 1)}
                    disabled={currentPage === 1}
                    style={{
                      padding: "10px 20px",
                      cursor: currentPage === 1 ? "not-allowed" : "pointer",
                      opacity: currentPage === 1 ? 0.5 : 1,
                      backgroundColor: "#007bff",
                      color: "white",
                      border: "none",
                      borderRadius: "4px",
                    }}
                  >
                    Previous
                  </button>
                  <span style={{ padding: "10px 20px", fontWeight: "bold" }}>
                    Page {currentPage}
                  </span>
                  <button
                    onClick={() => setCurrentPage(currentPage + 1)}
                    style={{
                      padding: "10px 20px",
                      cursor: "pointer",
                      backgroundColor: "#007bff",
                      color: "white",
                      border: "none",
                      borderRadius: "4px",
                    }}
                  >
                    Next
                  </button>
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
      {/*=== BLOG AREA END === */}

      <Footer />
    </>
  );
}

export default Blog;
